import React from "react";
import StaffCompliancePage from "./staff-compliance";

export default function TipsGuidesPage() {
  return <StaffCompliancePage />;
}
